export enum IncentiveFamilyView {
  COMBINED = 'combined',
  RDTAX = 'rdtax',
  IPTAX = 'iptax'
}
